import React from 'react';
import { Header } from '../components/Header';
export const TermsPage = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12, padding: 12, maxWidth: 1200, margin: '0 auto' }}>
      <Header />

  <h1>Terms of Service</h1>
  <p>Effective date: January 30, 2026</p>

  <h2>Acceptance of Terms</h2>
  <p>By using this application, you agree to be bound by these Terms of Service. If you do not agree, do not use the app.</p>

  <h2>Use of the App</h2>
  <p>You may use the app only for lawful purposes and in accordance with these terms. You agree not to:</p>
  <ul>
    <li>Violate any laws or regulations</li>
    <li>Interfere with the app’s operation</li>
    <li>Upload harmful or illegal content</li>
  </ul>

  <h2>Account Responsibilities</h2>
  <p>You are responsible for maintaining the confidentiality of your account credentials and for all activity under your account.</p>

  <h2>Intellectual Property</h2>
  <p>All content, logos, and materials in this app are owned by us or our licensors. You may not copy, distribute, or create derivative works without permission.</p>

  <h2>Disclaimer and Limitation of Liability</h2>
  <p>The app is provided "as is". We are not liable for any damages arising from use of the app.</p>

  <h2>Governing Law</h2>
  <p>These terms are governed by the laws of the United States. Any disputes will be resolved in the appropriate courts.</p>

  <h2>Contact Us</h2>
  <p>For questions regarding these Terms of Service, contact us at: <a href="mailto:info@nhenews.com">info@nhenews.com</a></p>
    </div>
  );
};
